


















































import {
  defineComponent,
  getCurrentInstance,
  nextTick,
  ref,
  onUpdated,
  onBeforeMount,
  watch,
} from '@vue/composition-api';

const name = 'ttam-show-more-options';
export default defineComponent({
  name,
  props: {
    dataTea: {
      type: String,
      default: '',
    },
    dataTeaExpose: {
      type: String,
      default: '',
    },
    label: {
      type: String,
      default: '',
    },
    labelClass: {
      type: String,
      default: '',
    },
    showText: {
      type: String,
      default: '',
    },
    hideText: {
      type: String,
      default: '',
    },
    hideContainer: {
      type: Boolean,
      default: false,
    },
    hideIfNoContent: {
      type: Boolean,
      default: false,
    },
    containerPlacement: {
      type: String,
      default: 'bottom',
    },
    defalutShow: {
      type: Boolean,
      default: false,
    },
  },
  setup(props, { emit }) {
    const curActive = ref(props.defalutShow);

    const onExpand = () => {
      curActive.value = !curActive.value;
      emit('expand', curActive.value);
    };

    const instance = getCurrentInstance()!.proxy;

    const shouldHide = ref(false);
    function checkIfShouldHide() {
      nextTick(() => {
        if (!props.hideIfNoContent) {
          return (shouldHide.value = false);
        }

        shouldHide.value =
          !instance.$slots.default?.length ||
          instance.$slots.default.every?.(vNode => !vNode.elm || String(vNode.elm) === '[object Comment]');

        if (shouldHide.value) {
          curActive.value = false;
        }
      });
    }

    onBeforeMount(checkIfShouldHide);
    onUpdated(checkIfShouldHide);
    watch(() => props.hideIfNoContent, checkIfShouldHide);

    return {
      curActive,
      onExpand,
      shouldHide,
      name,
    };
  },
});
